
<template>
  <div class="admin-container">
    <!-- Modal de contraseña -->
    <div v-if="!isAuthenticated" class="password-modal-overlay">
      <div class="password-modal">
        <div class="modal-header">
          <h2><i class="bi bi-shield-lock"></i> Acceso Administrativo</h2>
          <div class="security-badge">NVL L2</div>
        </div>

        <div class="modal-body">

  <!-- ✅ AGREGAR ESTO: -->
  <div v-if="isPrivateAccess" class="private-access-notice">
    <i class="bi bi-info-circle"></i>
    <p>Este sitio requiere contraseña para acceder. Ingresa la contraseña maestra para continuar.</p>
  </div>

          <div class="password-input-container" :class="{ 'shake': shakeInput }">
            <label for="adminPassword">Contraseña Maestra:</label>
            <div class="input-wrapper">
              <input id="adminPassword" v-model="passwordInput" :type="showPassword ? 'text' : 'password'"
                placeholder="Ingresa la contraseña..." @keyup.enter="attemptLogin" class="password-input" />
              <button @click="togglePasswordVisibility" class="visibility-toggle" type="button">
                <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </button>
            </div>
            <div class="password-strength" v-if="passwordInput.length > 0">
              <div class="strength-bar" :class="getPasswordStrengthClass"></div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="attemptLogin" class="login-btn" :disabled="!passwordInput">
            <i class="bi bi-rocket-takeoff"></i> Acceder al Panel
          </button>
          <button @click="emergencyExit" class="exit-btn">
            <i class="bi bi-box-arrow-right"></i> Salir
          </button>
        </div>

        <div class="security-notice">
          <p><i class="bi bi-exclamation-triangle"></i> Intento #{{ loginAttempts }}/5 - Acceso monitoreado</p>
        </div>
      </div>
    </div>

    <!-- Panel Admin Principal -->
    <div v-else class="admin-panel">
      <!-- Header del Panel -->
      <header class="admin-header">
        <div class="header-left">
          <div class="admin-logo">
            <img src="../assets/images/Logo.png" width="40" height="40" alt="Admin L2" />
            <span class="admin-title">Panel de Control L2</span>
          </div>
          <div class="admin-status">
            <span class="status-badge" :class="getSystemStatusClass">
              {{ getSystemStatusText }}
            </span>
          </div>
        </div>

        <div class="header-right">
          <button @click="downloadManual" class="manual-btn">
            <i class="bi bi-file-text"></i> Descargar Manual
          </button>
          <button @click="logout" class="logout-btn">
            <i class="bi bi-box-arrow-right"></i> Cerrar Sesión
          </button>
        </div>
      </header>

      <!-- Contenido del Panel -->
      <main class="admin-main">
        <!-- Navegación -->
        <nav class="admin-nav">
          <button v-for="section in sections" :key="section.id" @click="activeSection = section.id" class="nav-btn"
            :class="{ active: activeSection === section.id }">
            <i :class="'bi ' + section.icon"></i> {{ section.name }}
          </button>
        </nav>

        <!-- ==================== SECCIÓN: CONTROL GENERAL ==================== -->
        <section v-if="activeSection === 'general'" class="section-content">
          <h2 class="section-title"><i class="bi bi-gear"></i> Control General del Sitio</h2>

          <div class="controls-grid-general-2x3">
            <!-- Fila 1: Mantenimiento + Acceso Privado + Control Accesos -->
            <div class="grid-row-1">
              <!-- Card Mantenimiento -->
              <div class="control-card mantenimiento">
                <div class="control-header">
                  <h3><i class="bi bi-tools"></i> Modo Mantenimiento</h3>
                  <label class="switch">
                    <input type="checkbox" v-model="maintenanceMode" @change="toggleMaintenance">
                    <span class="slider"></span>
                  </label>
                </div>
                <p>Activa una página de mantenimiento para todos los visitantes</p>
                <div v-if="maintenanceMode" class="control-options">
                  <textarea v-model="maintenanceMessage" placeholder="Mensaje personalizado de mantenimiento..."
                    class="message-input"></textarea>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="maintenanceAllowAdmin">
                    <span class="checkmark"></span>
                    Permitir acceso a administradores
                  </label>
                </div>
              </div>

              <!-- Card Acceso Privado -->
              <div class="control-card acceso">
                <div class="control-header">
                  <h3><i class="bi bi-shield-lock"></i> Acceso Privado</h3>
                  <label class="switch">
                    <input type="checkbox" v-model="privateAccess" @change="togglePrivateAccess">
                    <span class="slider"></span>
                  </label>
                </div>
                <p>Requiere contraseña maestra para acceder a cualquier página del sitio</p>
              </div>

              <!-- Card Control Accesos (OCUPA ALTURA COMPLETA) -->
          <!-- Card Control Accesos (OCUPA ALTURA COMPLETA) -->
<div class="control-card control control-card-tall">
  <div class="control-header">
    <h3><i class="bi bi-globe"></i> Control Acceso Páginas</h3>
  </div>
  <p>Activa/desactiva el acceso a páginas específicas</p>

  <div class="pages-list">
    <div v-for="page in pagesList" :key="page.id" class="page-item" :class="{ blocked: page.blocked }">
      <span class="page-name">{{ page.nombre }}</span>
      <label class="switch switch-small">
        <input type="checkbox" :checked="!page.blocked" @change="togglePageAccess(page.id)">
        <span class="slider"></span>
      </label>
      <span class="page-status" :class="page.blocked ? 'blocked' : 'active'">
        {{ page.blocked ? 'Bloqueada' : 'Activa' }}
      </span>
    </div>
  </div>
</div>
            </div>

            <!-- Fila 2: Alertas Sistema + Personalizar Tema -->
            <div class="grid-row-2">
              <!-- Card Alertas Sistema -->
              <div class="control-card alertas">
                <div class="control-header">
                  <h3><i class="bi bi-bell"></i> Alertas del Sistema</h3>
                  <button @click="refreshAlerts" class="refresh-btn">
                    <i class="bi bi-arrow-clockwise"></i>
                  </button>
                </div>

                <div class="alerts-list">
                  <div class="alert-item" :class="getAlertClass(alert.type)" v-for="alert in systemAlerts"
                    :key="alert.id">
                    <span class="alert-icon"><i :class="'bi ' + getAlertIcon(alert.type)"></i></span>
                    <span class="alert-text">{{ alert.message }}</span>
                    <span class="alert-time">{{ alert.time }}</span>
                  </div>

                  <div v-if="systemAlerts.length === 0" class="no-alerts">
                    <i class="bi bi-check-circle"></i> Todo funciona correctamente
                  </div>
                </div>

                <div class="alerts-stats">
                  <span class="stat">Total: {{ systemAlerts.length }} alertas</span>
                  <span class="stat">Hoy: {{ todayAlerts }} alertas</span>
                </div>
              </div>

              <!-- Card Personalizar Tema -->
              <div class="control-card tema">
                <div class="control-header">
                  <h3><i class="bi bi-palette"></i> Personalizar Tema</h3>
                </div>
                <div class="theme-controls">
                  <div class="theme-presets">
                    <button v-for="preset in themePresets" :key="preset.name" @click="applyThemePreset(preset)"
                      class="preset-btn" :style="{
                        background: preset.colors.primary,
                        border: activeTheme === preset.name ? '2px solid var(--color-text-primary)' : 'none'
                      }">
                      {{ preset.name }}
                    </button>
                  </div>
                  <div class="color-customization">
                    <div class="color-picker-group">
                      <label><i class="bi bi-droplet"></i> Color Primario:</label>
                      <input type="color" v-model="themeColors.primary" @change="updateTheme">
                    </div>
                    <div class="color-picker-group">
                      <label><i class="bi bi-droplet"></i> Color Fondo:</label>
                      <input type="color" v-model="themeColors.background" @change="updateTheme">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ==================== SECCIÓN: SEGURIDAD ==================== -->
        <section v-if="activeSection === 'security'" class="section-content">
          <h2 class="section-title"><i class="bi bi-shield-check"></i> Seguridad y Auditoría</h2>

          <div class="controls-grid-security-uniform">
            <!-- Card 1: Configuración Avanzada -->
            <div class="control-card security-card">
              <div class="control-header">
                <h3><i class="bi bi-gear"></i> Configuración Avanzada</h3>
                <span class="advanced-badge">ADV</span>
              </div>

              <div class="advanced-controls">
                <div class="setting-group">
                  <label>Nivel de Seguridad:</label>
                  <select v-model="securityLevel" @change="updateSecurityLevel" class="security-select">
                    <option value="1">1 - Básico</option>
                    <option value="2">2 - Estándar</option>
                    <option value="3">3 - Alto</option>
                    <option value="4">4 - Máximo</option>
                  </select>
                </div>

                <div class="setting-group">
                  <label>Contraseña Maestra:</label>
                  <div class="password-change">
                    <input v-model="newMasterPassword" type="password" placeholder="Nueva contraseña..."
                      class="password-input-small" />
                    <button @click="changeMasterPassword" class="save-btn">
                      <i class="bi bi-key"></i> Cambiar
                    </button>
                  </div>
                </div>

                <div class="setting-group">
                  <label>Auto-logout (minutos):</label>
                  <input type="number" v-model="autoLogoutMinutes" min="5" max="240" class="number-input">
                  <small>Se guarda automáticamente</small>
                </div>

                <button @click="saveSecuritySettings" class="save-btn full-width">
                  <i class="bi bi-save"></i> Guardar Configuración
                </button>
              </div>
            </div>

            <!-- Card 2: Firewall Web -->
            <div class="control-card security-card">
              <div class="control-header">
                <h3><i class="bi bi-fire"></i> Firewall Web</h3>
                <label class="switch">
                  <input type="checkbox" v-model="firewallEnabled" @change="toggleFirewall">
                  <span class="slider"></span>
                </label>
              </div>

              <div class="firewall-controls">
                <div class="ip-management">
                  <h4>Bloqueo Manual de IPs</h4>
                  <div class="ip-input-group">
                    <input v-model="newIP" placeholder="Ej: 192.168.1.1" class="ip-input">
                    <button @click="blockIP" class="action-btn">
                      <i class="bi bi-ban"></i> Bloquear
                    </button>
                  </div>
                </div>

                <div class="ip-management">
                  <h4>Bloqueo por País</h4>
                  <select v-model="selectedCountry" class="country-select">
                    <option value="">Seleccionar país...</option>
                    <option value="CN">China</option>
                    <option value="RU">Rusia</option>
                    <option value="BR">Brasil</option>
                    <option value="IN">India</option>
                  </select>
                  <button @click="toggleCountryBlock" class="action-btn">
                    {{ blockedCountries.includes(selectedCountry) ? 'Desbloquear' : 'Bloquear' }}
                  </button>
                </div>

                <div class="active-blocks">
                  <h4>Bloqueos Activos</h4>
                  <div class="blocked-list">
                    <div v-for="ip in blockedIPs.slice(0, 3)" :key="ip" class="blocked-item">
                      <span class="blocked-ip">{{ ip }}</span>
                      <button @click="unblockIP(ip)" class="remove-btn">
                        <i class="bi bi-x-circle"></i>
                      </button>
                    </div>
                    <div v-if="blockedIPs.length > 3" class="more-blocks">
                      +{{ blockedIPs.length - 3 }} más...
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 3: Logs Sistema -->
            <div class="control-card security-card">
              <div class="control-header">
                <h3><i class="bi bi-journal-text"></i> Logs del Sistema</h3>
                <div class="log-controls">
                  <select v-model="logLevel" class="log-filter">
                    <option value="all">Todos</option>
                    <option value="info">Info</option>
                    <option value="warning">Warning</option>
                    <option value="error">Error</option>
                  </select>
                  <button @click="refreshLogs" class="refresh-btn">
                    <i class="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>

              <div class="logs-container-uniform">
                <div class="log-entries-uniform">
                  <div v-for="log in filteredLogs.slice(0, 6)" :key="log.id" class="log-entry" :class="log.level">
                    <span class="log-time">{{ formatTime(log.created_at) }}</span>
                    <span class="log-level" :class="log.level">
                      <i :class="'bi ' + getLogIcon(log.level)"></i>
                      {{ log.level.toUpperCase() }}
                    </span>
                    <span class="log-message">{{ log.message }}</span>
                  </div>
                </div>

                <div class="logs-stats-real">
                  <span class="stat">Total: {{ systemLogs.length }} logs</span>
                  <span class="stat">Hoy: {{ getTodayLogsCount() }} logs</span>
                  <button @click="exportLogs" class="export-btn">
                    <i class="bi bi-download"></i> Exportar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ==================== SECCIÓN: ANÁLISIS ==================== -->
        <section v-if="activeSection === 'analytics'" class="section-content">
          <h2 class="section-title"><i class="bi bi-graph-up"></i> Análisis y Monitoreo</h2>

          <div class="analytics-container">
            <!-- Cloudflare Analytics -->
            <div class="cloudflare-section">
              <div class="control-header">
                <h3><i class="bi bi-cloud"></i> Cloudflare Analytics</h3>
                <span class="api-status" :class="cfConnected ? 'connected' : 'disconnected'">
                  <i :class="cfConnected ? 'bi bi-check-circle' : 'bi bi-x-circle'"></i>
                  {{ cfConnected ? 'Conectado' : 'No conectado' }} a leonar2.pages.dev
                </span>
              </div>

              <div class="cloudflare-metrics">
                <div class="metrics-grid">
                  <div class="metric-card" v-for="metric in cloudflareMetrics" :key="metric.id">
                    <div class="metric-icon"><i :class="'bi ' + metric.icon"></i></div>
                    <div class="metric-data">
                      <span class="metric-value">{{ metric.value }}</span>
                      <span class="metric-label">{{ metric.label }}</span>
                    </div>
                  </div>
                </div>

                <!-- Gráfico -->
                <div class="charts-placeholder">
                  <h4><i class="bi bi-bar-chart"></i> Métricas de Cloudflare Pages</h4>
                  <p>Datos reales de tu sitio leonar2.pages.dev</p>
                  <div class="chart-container">
                    <div class="chart-placeholder">
                      <div class="placeholder-bars">
                        <div v-for="i in 12" :key="i" class="bar" :style="{ height: Math.random() * 100 + 'px' }"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <button @click="fetchCloudflareAnalytics" class="refresh-btn large">
                  <i class="bi bi-arrow-clockwise"></i> Actualizar Métricas Cloudflare
                </button>
              </div>
            </div>

            <!-- 3 Cards Inferiores -->
            <div class="analytics-cards-uniform">
              <!-- Google Analytics -->
              <div class="control-card analytics-card">
                <div class="control-header">
                  <h3><i class="bi bi-graph-up"></i> Google Analytics</h3>
                </div>
                <div class="ga-config">
                  <input v-model="gaTrackingID" placeholder="G-XXXXXXXXXX" class="api-input">
                  <button @click="saveGAConfig" class="save-btn">
                    <i class="bi bi-save"></i> Guardar
                  </button>
                </div>
              </div>

              <!-- Heatmaps -->
              <div class="control-card analytics-card">
                <div class="control-header">
                  <h3><i class="bi bi-heart"></i> Heatmaps</h3>
                  <label class="switch">
                    <input type="checkbox" v-model="heatmapsEnabled">
                    <span class="slider"></span>
                  </label>
                </div>
                <p>Rastrea clicks y movimientos del mouse</p>
                <div v-if="heatmapsEnabled" class="heatmap-controls">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="trackClicks">
                    <span class="checkmark"></span>
                    Trackear clicks
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="trackScroll">
                    <span class="checkmark"></span>
                    Trackear scroll
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="trackMouse">
                    <span class="checkmark"></span>
                    Trackear movimiento mouse
                  </label>
                </div>
              </div>

              <!-- Performance Monitor -->
              <div class="control-card analytics-card">
                <div class="control-header">
                  <h3><i class="bi bi-speedometer2"></i> Performance Monitor</h3>
                </div>
                <div class="performance-metrics">
                  <div class="perf-metric">
                    <span class="metric-label">Tiempo de Carga:</span>
                    <span class="metric-value">{{ performanceMetrics.loadTime }}ms</span>
                  </div>
                  <div class="perf-metric">
                    <span class="metric-label">Uso de Memoria:</span>
                    <span class="metric-value">{{ performanceMetrics.memory }}MB</span>
                  </div>
                  <div class="perf-metric">
                    <span class="metric-label">Requests Activos:</span>
                    <span class="metric-value">{{ performanceMetrics.requests }}</span>
                  </div>
                  <button @click="runPerformanceTest" class="action-btn">
                    <i class="bi bi-lightning"></i> Test de Performance
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ==================== SECCIÓN: HERRAMIENTAS DEV ==================== -->
        <section v-if="activeSection === 'devtools'" class="section-content">
          <h2 class="section-title"><i class="bi bi-tools"></i> Herramientas de Desarrollo</h2>

          <div class="devtools-container">
            <!-- 3 Cards Superiores -->
            <div class="devtools-cards-uniform">
              <!-- Acciones Rápidas -->
              <div class="control-card devtools-card">
                <div class="control-header">
                  <h3><i class="bi bi-lightning"></i> Acciones Rápidas</h3>
                </div>
                <div class="quick-actions-list-compact">
                  <button @click="quickAction('flushCache')" class="quick-action-btn">
                    <i class="bi bi-trash"></i> Limpiar Cache
                  </button>
                  <button @click="quickAction('restartServer')" class="quick-action-btn">
                    <i class="bi bi-arrow-repeat"></i> Reiniciar Servidor
                  </button>
                  <button @click="quickAction('generateReport')" class="quick-action-btn">
                    <i class="bi bi-graph-up"></i> Generar Reporte
                  </button>
                  <button @click="quickAction('optimizeDB')" class="quick-action-btn">
                    <i class="bi bi-database"></i> Optimizar DB
                  </button>
                </div>
                <button @click="executeAllActions" class="action-btn full-width">
                  <i class="bi bi-play-circle"></i> Ejecutar Todas
                </button>
              </div>

              <!-- Gestor Archivos -->
              <div class="control-card devtools-card">
                <div class="control-header">
                  <h3><i class="bi bi-folder"></i> Gestor de Archivos</h3>
                </div>
                <div class="file-stats-compact">
                  <div class="stat-item">
                    <i class="bi bi-file-earmark"></i>
                    <span>Archivos: 24</span>
                  </div>
                  <div class="stat-item">
                    <i class="bi bi-folder"></i>
                    <span>Carpetas: 8</span>
                  </div>
                  <div class="stat-item">
                    <i class="bi bi-clock"></i>
                    <span>Última mod: Hoy</span>
                  </div>
                </div>
                <button @click="openFileManager" class="action-btn full-width">
                  <i class="bi bi-folder2-open"></i> Abrir Gestor
                </button>
              </div>

              <!-- Backup Automático -->
              <div class="control-card devtools-card">
                <div class="control-header">
                  <h3><i class="bi bi-cloud-arrow-down"></i> Backup Automático</h3>
                </div>
                <div class="backup-info-compact">
                  <div class="backup-status">
                    <span class="status-badge active"><i class="bi bi-check-circle"></i> Activo</span>
                  </div>
                  <div class="backup-details">
                    <div class="detail-item">
                      <i class="bi bi-calendar-event"></i>
                      <span>Frecuencia: Diario</span>
                    </div>
                    <div class="detail-item">
                      <i class="bi bi-clock-history"></i>
                      <span>Último: Hoy 08:00</span>
                    </div>
                  </div>
                </div>
                <div class="backup-actions">
                  <button @click="createBackup" class="action-btn">
                    <i class="bi bi-plus-circle"></i> Crear Backup
                  </button>
                  <button @click="showBackups" class="action-btn">
                    <i class="bi bi-list-ul"></i> Ver
                  </button>
                </div>
              </div>
            </div>

            <!-- Botones de Cambio de Vista CENTRADOS -->
            <div class="view-buttons-centered">
              <button @click="activeView = 'console'" class="view-btn" :class="{ active: activeView === 'console' }">
                <i class="bi bi-terminal"></i> CONSOLA
              </button>
              <button @click="activeView = 'simulator'" class="view-btn"
                :class="{ active: activeView === 'simulator' }">
                <i class="bi bi-phone"></i> SIMULADOR
              </button>
            </div>

            <!-- Área de Trabajo CENTRADA -->
            <div class="work-area-centered">
              <!-- Consola REAL -->
              <div v-if="activeView === 'console'" class="console-real">
                <div class="console-header">
                  <h4><i class="bi bi-terminal"></i> Consola JavaScript</h4>
                  <button @click="clearConsole" class="clear-btn">
                    <i class="bi bi-trash"></i> Limpiar
                  </button>
                </div>
                <div class="console-output-real">
                  <div v-for="log in consoleLogs" :key="log.id" class="console-line" :class="log.type">
                    <span class="log-prefix">{{ log.type === 'command' ? '>' : '<<' }}</span>
                        <span class="log-message">{{ log.message }}</span>
                  </div>
                </div>
                <div class="console-input-integrated">
                  <span class="prompt">></span>
                  <input v-model="consoleInput" @keyup.enter="executeConsole" placeholder="Escribe código JavaScript..."
                    class="console-input-real">
                </div>
              </div>

              <!-- Simulador Responsive CENTRADO -->
              <div v-if="activeView === 'simulator'" class="simulator-centered">
                <div class="simulator-header">
                  <h4><i class="bi bi-phone"></i> Simulador de Dispositivos</h4>
                  <div class="device-controls">
                    <select v-model="selectedDevice" class="device-select">
                      <option value="mobile">Mobile (375x667)</option>
                      <option value="tablet">Tablet (768x1024)</option>
                      <option value="desktop">Desktop (1200x800)</option>
                    </select>
                    <button @click="refreshSimulator" class="refresh-btn">
                      <i class="bi bi-arrow-clockwise"></i> Actualizar
                    </button>
                  </div>
                </div>
                <div class="simulator-frame-centered" >
                  <iframe :src="previewUrl"  class="site-preview-responsive":class="getDeviceStyle"></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

    <!-- Notificaciones -->
    <div v-if="notification.show" class="notification" :class="notification.type">
      <i :class="'bi ' + getNotificationIcon(notification.type)"></i> {{ notification.message }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'AdminL2',
  data () {
    return {
      // === AUTENTICACIÓN ===
      isAuthenticated: false,
      loginAttempts: 0,
      shakeInput: false,
      showPassword: false,
      passwordInput: '',
      adminToken: '',
      autoLogoutTimer: null,
      autoLogoutDebounce: null,
      isLoading: false,

      // === NOTIFICACIONES ===
      notification: {
        show: false,
        message: '',
        type: 'info'
      },
isPrivateAccess: false,
      // === NAVEGACIÓN ===
      activeSection: 'general',
      sections: [
        { id: 'general', name: 'Control General', icon: 'bi-gear' },
        { id: 'security', name: 'Seguridad', icon: 'bi-shield-check' },
        { id: 'analytics', name: 'Análisis', icon: 'bi-graph-up' },
        { id: 'devtools', name: 'Herramientas Dev', icon: 'bi-tools' }
      ],

      // === CONTROL GENERAL ===
      maintenanceMode: false,
      maintenanceMessage: 'Sitio en mantenimiento. Volvemos pronto.',
      maintenanceAllowAdmin: true,
      privateAccess: false,

      // Páginas
      pagesList: [
        { id: 'inicio', nombre: 'Inicio', ruta: '/', bloqueada: false },
        { id: 'yo', nombre: 'Yo', ruta: '/Yo', bloqueada: false },
        { id: 'contacto', nombre: 'Contacto', ruta: '/Contacto', bloqueada: false },
        { id: 'servicios', nombre: 'Servicios', ruta: '/Servicios', bloqueada: false },
        { id: 'ejemplos', nombre: 'Ejemplos', ruta: '/Ejemplos', bloqueada: false },

      ],

      // Sistema de Alertas
      systemAlerts: [],
      todayAlerts: 0,

      // Temas
      themeColors: {
        primary: '#5c8df6',
        background: '#1a1f2e',
        textPrimary: '#ffffff',
        textSecondary: '#b0b0b0'
      },
      activeTheme: 'Blue Mist',
      themePresets: [
        {
          name: 'Blue Mist',
          colors: {
            primary: '#5c8df6',
            background: '#1a1f2e',
            textPrimary: '#ffffff',
            textSecondary: '#b0b0b0'
          }
        }
      ],

      // === SEGURIDAD ===
      securityLevel: '2',
      newMasterPassword: '',
      autoLogoutMinutes: 30,
      firewallEnabled: false,
      blockedIPs: [],
      newIP: '',
      blockedCountries: [],
      selectedCountry: '',
      systemLogs: [],
      logLevel: 'all',

      // === ANÁLISIS ===
      cfConnected: false,
      cloudflareMetrics: [
        { id: 1, icon: 'bi-people', value: '1,247', label: 'Visitas' },
        { id: 2, icon: 'bi-graph-up', value: '156MB', label: 'Banda' },
        { id: 3, icon: 'bi-shield-check', value: '8', label: 'Amenazas' },
        { id: 4, icon: 'bi-hdd', value: '78%', label: 'Cache' },
        { id: 5, icon: 'bi-eye', value: '3,458', label: 'Pageviews' }
      ],
      gaTrackingID: '',
      fileStats: { files: 0, folders: 0, lastModified: 'Hoy', totalSize: '0 MB' },
      heatmapsEnabled: false,
      trackClicks: true,
      trackScroll: true,
      trackMouse: false,
      performanceMetrics: { loadTime: 320, memory: 45, requests: 12 },

      // === HERRAMIENTAS DEV ===
      activeView: 'console',
      selectedDevice: 'mobile',
      previewUrl: '/',
      consoleLogs: [],
      consoleInput: '',

      // === CONFIGURACIÓN BACKEND ===
      backendUrl: 'https://leonar2backend-production.up.railway.app',

      // === NUEVO: Timers organizados ===
      timers: {
        autoLogout: null,
        debounce: null,
        notification: null
      }
    }
  },

  computed: {
    getPasswordStrengthClass () {
      if (!this.passwordInput) return 'empty';
      if (this.passwordInput.length < 4) return 'weak';
      if (this.passwordInput.length < 8) return 'medium';
      return 'strong';
    },

    getSystemStatusClass () {
      if (this.maintenanceMode) return 'maintenance';
      if (this.privateAccess) return 'private';
      return 'active';
    },

    getSystemStatusText () {
      if (this.maintenanceMode) return 'Mantenimiento';
      if (this.privateAccess) return 'Privado';
      return 'Activo';
    },

    filteredLogs () {
      if (this.logLevel === 'all') return this.systemLogs;
      return this.systemLogs.filter(log => log.level === this.logLevel);
    },

    // === NUEVO: Computed para el simulador ===
   // En tu computed property, cambia a usar clases
getDeviceStyle() {
  const devices = {
    mobile: 'mobile-device',
    tablet: 'tablet-device', 
    desktop: 'desktop-device'
  };
  return devices[this.selectedDevice] || 'mobile-device';
}
  },

  methods: {
    // === DESCARGAR MANUAL PDF ===
    downloadManual () {
      const manualContent = 'MANUAL PANEL ADMIN L2\n=====================\n\nSECCIONES:\n\n1. CONTROL GENERAL\n- Modo Mantenimiento\n- Acceso Privado\n- Control Accesos\n- Alertas Sistema\n- Personalizar Tema';

      const blob = new Blob([manualContent], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Manual_Panel_Admin_L2.txt';
      a.click();
      URL.revokeObjectURL(url);

      this.showNotification('Manual descargado', 'success');
    },

    // === AUTENTICACIÓN MEJORADA ===
    async attemptLogin () {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        // Verificar si viene de acceso privado
        const urlParams = new URLSearchParams(window.location.search);
        const fromPrivate = urlParams.get('private') === 'true';

        const data = await this.apiCall('/api/login', {
          method: 'POST',
          body: JSON.stringify({
            password: this.passwordInput,
            fromPrivate: fromPrivate
          })
        });

        if (data.success) {
          this.isAuthenticated = true;
          sessionStorage.setItem('adminToken', data.token);
          sessionStorage.setItem('tokenExpiry', Date.now() + (this.autoLogoutMinutes * 60 * 1000));
          this.adminToken = data.token;

          this.showNotification('Acceso concedido al Panel L2', 'success');

          // ✅ SI VIENE DE ACCESO PRIVADO, REDIRIGIR A LA PÁGINA PRINCIPAL
          if (fromPrivate) {
            setTimeout(() => {
              window.location.href = '/'; // O la página que intentaba acceder
            }, 1000);
          } else {
            await this.loadInitialData();
            this.setupAutoLogout();
          }
        }
      } catch (error) {
        this.handleLoginError();
      } finally {
        this.isLoading = false;
      }
    },
    // === NUEVO: Verificar estado de páginas al cargar ===
    async verifyPagesState () {
      try {
        const data = await this.apiCall('/api/pages');
        if (data && data.pages) {
          // Verificar si hay diferencias entre frontend y backend
          data.pages.forEach(backendPage => {
            const localPage = this.pagesList.find(p => p.id === backendPage.page_id);
            if (localPage && localPage.blocked !== backendPage.bloqueada) {
              console.log(`🔄 Sincronizando página ${localPage.nombre} con BD`);
              localPage.blocked = backendPage.bloqueada;
            }
          });
        }
      } catch (error) {
        console.error('Error verificando estado de páginas:', error);
      }
    },
    // === CORREGIDO: loadSettings SIN loops y CON carga correcta ===
    async loadSettings () {
      try {
        const settings = await this.apiCall('/api/settings');

        console.log('🔄 Cargando configuración desde BD:', settings);

        // ✅ CORREGIDO: Conversión EXPLÍCITA y segura
        this.maintenanceMode = settings.maintenance_mode === true || settings.maintenance_mode === '1' || settings.maintenance_mode === 1;
        this.privateAccess = settings.private_access === true || settings.private_access === '1' || settings.private_access === 1;
        this.firewallEnabled = settings.firewall_enabled === true || settings.firewall_enabled === '1' || settings.firewall_enabled === 1;

        this.securityLevel = settings.security_level || '2';
        this.autoLogoutMinutes = parseInt(settings.auto_logout_minutes) || 30;
        this.maintenanceMessage = settings.maintenance_message || 'Sitio en mantenimiento. Volvemos pronto.';

        // Tema - SIN guardar automáticamente
        if (settings.theme_data) {
          try {
            const theme = typeof settings.theme_data === 'string'
              ? JSON.parse(settings.theme_data)
              : settings.theme_data;
            this.themeColors = { ...this.themeColors, ...theme };
            this.updateTheme();
          } catch (e) {
            console.error('Error parsing theme:', e);
          }
        }

        console.log('✅ Configuración cargada CORRECTAMENTE:', {
          maintenance: this.maintenanceMode,
          private: this.privateAccess,
          firewall: this.firewallEnabled,
          security: this.securityLevel
        });
      } catch (error) {
        console.error('Error loading settings:', error);
        // ✅ Mantener valores por defecto si hay error
      }
    },

    handleLoginError () {
      this.loginAttempts++;
      this.shakeInput = true;
      this.showNotification(`Contraseña incorrecta - Intento ${this.loginAttempts}/5`, 'error');
      setTimeout(() => this.shakeInput = false, 500);

      if (this.loginAttempts >= 5) {
        this.emergencyExit();
      }
    },

    togglePasswordVisibility () {
      this.showPassword = !this.showPassword;
    },

    emergencyExit () {
      sessionStorage.removeItem('adminToken');
      sessionStorage.removeItem('tokenExpiry');
      this.isAuthenticated = false;
      this.passwordInput = '';
      window.location.href = '/';
    },

    // === CORREGIDO: applyThemePreset ===
    applyThemePreset (preset) {
      this.themeColors = { ...preset.colors };
      this.activeTheme = preset.name;
      this.updateTheme();
      this.saveSettings();
      this.showNotification(`Tema ${preset.name} aplicado`, 'success');
    },

    // === CORREGIDO: updateTheme SIN guardar automático ===
    updateTheme () {
      const root = document.documentElement;
      root.style.setProperty('--color-primary', this.themeColors.primary);
      root.style.setProperty('--color-background', this.themeColors.background);
      root.style.setProperty('--color-text-primary', this.themeColors.textPrimary);
      root.style.setProperty('--color-text-secondary', this.themeColors.textSecondary);
    },

    updateGlobalCSS (colors) {
      const newCSS = `
:root {
  --color-primary: ${colors.primary};
  --color-background: ${colors.background};
  --color-text-primary: ${colors.textPrimary};
  --color-text-secondary: ${colors.textSecondary};
}`;

      this.apiCall('/api/update-css', {
        method: 'POST',
        body: JSON.stringify({ css: newCSS })
      });
    },

    // === AUTO-LOGOUT FUNCIONAL ===
    setupAutoLogout () {
      if (this.timers.autoLogout) {
        clearTimeout(this.timers.autoLogout);
      }

      const minutes = this.autoLogoutMinutes || 30;
      this.timers.autoLogout = setTimeout(() => {
        this.showNotification('Sesión cerrada por inactividad', 'warning');
        this.logout();
      }, minutes * 60 * 1000);
    },

    // ✅ CORREGIDO: verifyAuth mejorado
    async verifyAuth () {
      try {
        const token = sessionStorage.getItem('adminToken');
        const expiry = sessionStorage.getItem('tokenExpiry');

        if (token && expiry && Date.now() < parseInt(expiry)) {
          this.adminToken = token;
          this.isAuthenticated = true;

          // ✅ CORREGIDO: Cargar datos INMEDIATAMENTE después de verificar auth
          await this.loadInitialData();
          this.setupAutoLogout();
          return true;
        } else {
          this.logout();
          return false;
        }
      } catch (error) {
        console.error('Error en verifyAuth:', error);
        this.logout();
        return false;
      }
    },

   // En el método logout del componente Vue
// En el método logout del componente Vue
logout () {
  this.clearAllTimers();
  sessionStorage.removeItem('adminToken');
  sessionStorage.removeItem('tokenExpiry');
  this.isAuthenticated = false;
  this.passwordInput = '';
  this.loginAttempts = 0;
  this.adminToken = '';
  this.showNotification('Sesión administrativa cerrada', 'info');

  // También cerrar sesión de acceso privado
  if (window.privateAccessManager) {
    window.privateAccessManager.logout();
  } else {
    // Fallback si no está cargado el manager
    sessionStorage.removeItem('privateAccessToken');
    sessionStorage.removeItem('privateTokenExpiry');
  }
},
    // ✅ CORREGIDO: loadInitialData mejorado
    // === CORREGIDO: loadInitialData MEJORADO ===
    async loadInitialData () {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        console.log('🔄 Iniciando carga de datos iniciales...');

        // ✅ CORREGIDO: Cargar settings PRIMERO
        await this.loadSettings();

        // ✅ CORREGIDO: Cargar páginas SEGUNDO (crítico)
        await this.loadPagesData();

        // Cargar el resto de datos en paralelo
        await Promise.allSettled([
          this.loadSecurityData(),
          this.loadAlertsData(),
          this.fetchCloudflareAnalytics()
        ]);

        console.log('✅ Todos los datos iniciales cargados');
      } catch (error) {
        console.error('Error loading initial data:', error);
        this.showNotification('Error cargando datos iniciales', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    async loadAdditionalData () {
      try {
        await Promise.allSettled([
          this.loadPagesData(),
          this.loadSecurityData(),
          this.loadAlertsData()
        ]);
      } catch (error) {
        console.error('Error loading additional data:', error);
      }
    },

    // ✅ CORREGIDO: loadPagesData mejorado
    // === CORREGIDO: loadPagesData MEJORADO ===
    async loadPagesData () {
      try {
        console.log('🔄 Cargando estado de páginas desde BD...');
        const data = await this.apiCall('/api/pages');
        console.log('📄 Datos de páginas recibidos:', data);

        if (data && data.pages) {
          // ✅ CORREGIDO: Sincronizar completamente con BD
          this.pagesList = this.pagesList.map(page => {
            const backendPage = data.pages.find(p => p.page_id === page.id);
            if (backendPage) {
              // Usar el estado directamente de la BD
              return {
                ...page,
                bloqueada: backendPage.bloqueada === true || backendPage.bloqueada === 1
              };
            }
            return page;
          });

          console.log('✅ Lista final de páginas sincronizada:', this.pagesList);
        }
      } catch (error) {
        console.error('❌ Error cargando páginas:', error);
        this.showNotification('Error cargando estado de páginas', 'error');
      }
    },
    async loadSecurityData () {
      try {
        const [ipsData, logsData] = await Promise.allSettled([
          this.apiCall('/api/blocked-ips'),
          this.apiCall('/api/logs')
        ]);

        this.blockedIPs = ipsData.status === 'fulfilled' ? (ipsData.value?.ips || []) : [];
        this.systemLogs = logsData.status === 'fulfilled' ? (logsData.value || this.generateDefaultLogs()) : this.generateDefaultLogs();
      } catch (error) {
        console.error('Error loading security data:', error);
      }
    },

    async loadAlertsData () {
      try {
        this.systemAlerts = this.generateDefaultAlerts();
        this.todayAlerts = this.systemAlerts.filter(alert =>
          this.isToday(alert.timestamp)
        ).length;
      } catch (error) {
        console.error('Error loading alerts:', error);
      }
    },

    // === CONFIGURACIÓN REAL ===
    async saveSettings () {
      try {
        console.log('💾 Guardando settings en BD:', {
          maintenance: this.maintenanceMode,
          private: this.privateAccess,
          firewall: this.firewallEnabled
        });

        await this.apiCall('/api/settings', {
          method: 'POST',
          body: JSON.stringify({
            maintenance_mode: this.maintenanceMode,
            maintenance_message: this.maintenanceMessage,
            private_access: this.privateAccess,
            theme_data: this.themeColors,
            security_level: this.securityLevel,
            auto_logout_minutes: this.autoLogoutMinutes,
            firewall_enabled: this.firewallEnabled
          })
        });

        this.showNotification('Configuración guardada', 'success');
      } catch (error) {
        console.error('Error saving settings:', error);
        this.showNotification('Error guardando configuración', 'error');
      }
    },

    // === CONTROL GENERAL ===
    async toggleMaintenance () {
      console.log('🔧 Cambiando maintenance mode a:', this.maintenanceMode);
      await this.saveSettings();
      this.showNotification(
        this.maintenanceMode ? 'Modo mantenimiento activado' : 'Sitio activo nuevamente',
        'success'
      );
    },

async togglePrivateAccess () {
  try {
    console.log('🔒 Cambiando private access a:', this.privateAccess);

    // Primero guardar en la base de datos
    await this.apiCall('/api/enforce-private-access', {
      method: 'POST',
      body: JSON.stringify({
        enabled: this.privateAccess
      })
    });

    // Luego guardar settings generales
    await this.saveSettings();

    if (this.privateAccess) {
      this.showNotification('🔒 Acceso privado ACTIVADO - El sitio ahora requiere contraseña', 'success');

      // ✅ FORZAR recarga del estado de acceso privado
      setTimeout(() => {
        // Verificar el estado actual en la base de datos
        this.loadSettings();
      }, 500);
    } else {
      this.showNotification('🔓 Acceso privado DESACTIVADO - Sitio público', 'success');

      // ✅ FORZAR recarga del estado
      setTimeout(() => {
        this.loadSettings();
      }, 500);
    }
  } catch (error) {
    console.error('Error activando acceso privado:', error);
    this.showNotification('Error activando acceso privado', 'error');
    // Revertir el cambio en caso de error
    this.privateAccess = !this.privateAccess;
  }
},
    // === CONTROL DE PÁGINAS ===
    // === CORREGIDO: togglePageAccess MEJORADO ===
    async togglePageAccess (pageId) {
      try {
        const page = this.pagesList.find(p => p.id === pageId);
        const newBlockedState = !page.blocked;

        console.log('🔄 Cambiando página:', page.nombre, 'de', page.blocked ? 'BLOQUEADA' : 'ACTIVA', 'a', newBlockedState ? 'BLOQUEADA' : 'ACTIVA');

        // ✅ CORREGIDO: Actualizar estado local INMEDIATAMENTE para feedback visual
        page.blocked = newBlockedState;

        const response = await this.apiCall('/api/toggle-page', {
          method: 'POST',
          body: JSON.stringify({
            page_id: pageId,
            blocked: newBlockedState
          })
        });

        if (response.success) {
          this.showNotification(
            `Página "${page.nombre}" ${newBlockedState ? 'BLOQUEADA' : 'ACTIVA'}`,
            newBlockedState ? 'warning' : 'success'
          );

          // ✅ CORREGIDO: Recargar datos para confirmar sincronización
          setTimeout(() => {
            this.loadPagesData();
          }, 500);
        } else {
          throw new Error('Error del servidor');
        }
      } catch (error) {
        console.error('❌ Error cambiando estado:', error);
        this.showNotification('Error cambiando estado: ' + error.message, 'error');

        // ✅ CORREGIDO: Revertir cambio local si falla
        const page = this.pagesList.find(p => p.id === pageId);
        page.blocked = !page.blocked;
      }
    },

    // === SISTEMA DE ALERTAS ===
    generateDefaultAlerts () {
      return [
        {
          id: 1,
          type: 'warning',
          message: 'Backup pendiente',
          time: 'Hace 2h',
          timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000)
        },
        {
          id: 2,
          type: 'success',
          message: 'SSL activo',
          time: 'Ahora',
          timestamp: new Date()
        }
      ];
    },

    getAlertClass (type) {
      return {
        'alert-warning': type === 'warning',
        'alert-success': type === 'success',
        'alert-info': type === 'info',
        'alert-error': type === 'error'
      };
    },

    getAlertIcon (type) {
      const icons = {
        warning: 'bi-exclamation-triangle',
        success: 'bi-check-circle',
        info: 'bi-arrow-clockwise',
        error: 'bi-x-circle'
      };
      return icons[type] || 'bi-info-circle';
    },

    async refreshAlerts () {
      await this.loadAlertsData();
      this.showNotification('Alertas actualizadas', 'success');
    },

    isToday (timestamp) {
      const today = new Date();
      const alertDate = new Date(timestamp);
      return today.toDateString() === alertDate.toDateString();
    },

    // === SEGURIDAD - CONFIGURACIÓN AVANZADA ===
    async saveSecuritySettings () {
      try {
        await this.apiCall('/api/security-settings', {
          method: 'POST',
          body: JSON.stringify({
            security_level: this.securityLevel,
            auto_logout_minutes: this.autoLogoutMinutes
          })
        });
        this.showNotification('Configuración de seguridad guardada', 'success');
      } catch (error) {
        this.showNotification('Error al guardar configuración de seguridad', 'error');
      }
    },

    async changeMasterPassword () {
      if (!this.newMasterPassword) {
        this.showNotification('Ingresa una nueva contraseña', 'error');
        return;
      }

      try {
        await this.apiCall('/api/change-master-password', {
          method: 'POST',
          body: JSON.stringify({ newPassword: this.newMasterPassword })
        });

        this.newMasterPassword = '';
        this.showNotification('Contraseña maestra cambiada', 'success');
      } catch (error) {
        this.showNotification('Error al cambiar contraseña', 'error');
      }
    },

    updateSecurityLevel () {
      clearTimeout(this.timers.debounce);
      this.timers.debounce = setTimeout(() => {
        this.saveSecuritySettings();
      }, 1000);
    },

    // === FIREWALL REAL ===
    async blockIP () {
      if (this.newIP && this.isValidIP(this.newIP) && !this.blockedIPs.includes(this.newIP)) {
        try {
          await this.apiCall('/api/block-ip', {
            method: 'POST',
            body: JSON.stringify({ ip: this.newIP, reason: 'Bloqueo manual' })
          });

          this.blockedIPs.push(this.newIP);
          this.newIP = '';
          this.showNotification('IP bloqueada', 'success');
        } catch (error) {
          this.showNotification('Error al bloquear IP', 'error');
        }
      } else {
        this.showNotification('IP inválida o ya bloqueada', 'error');
      }
    },

    async unblockIP (ip) {
      try {
        await this.apiCall('/api/unblock-ip', {
          method: 'POST',
          body: JSON.stringify({ ip })
        });

        this.blockedIPs = this.blockedIPs.filter(i => i !== ip);
        this.showNotification(`IP ${ip} desbloqueada`, 'success');
      } catch (error) {
        this.showNotification('Error al desbloquear IP', 'error');
      }
    },

    async toggleFirewall () {
      console.log('🔥 Cambiando firewall a:', this.firewallEnabled);
      await this.saveSettings();
      this.showNotification(
        this.firewallEnabled ? 'Firewall activado' : 'Firewall desactivado',
        this.firewallEnabled ? 'success' : 'warning'
      );
    },

    isValidIP (ip) {
      const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
      return ipRegex.test(ip);
    },

    // === SISTEMA DE LOGS REAL ===
    generateDefaultLogs () {
      return [
        {
          id: 1,
          level: 'info',
          message: 'Sistema iniciado correctamente',
          created_at: new Date().toISOString()
        }
      ];
    },

    async refreshLogs () {
      try {
        const logs = await this.apiCall('/api/logs');
        this.systemLogs = logs || this.generateDefaultLogs();
        this.showNotification('Logs actualizados', 'success');
      } catch (error) {
        console.error('Error refreshing logs:', error);
      }
    },

    async clearLogs () {
      console.log('🔍 1. Botón limpiar clickeado');

      try {
        console.log('🌐 2. Haciendo API call...');
        const response = await this.apiCall('/api/clear-logs', {
          method: 'POST'
        });

        console.log('✅ 3. Respuesta del backend:', response);

        if (response && response.success) {
          this.systemLogs = [];
          console.log('🗑️ 4. Logs limpiados localmente');
          this.showNotification('🗑️ Logs del sistema limpiados', 'success');
        } else {
          console.log('❌ 5. Respuesta no tiene success:', response);
          this.showNotification('❌ Error inesperado del servidor', 'error');
        }
      } catch (error) {
        console.error('💥 6. Error completo:', error);
        this.showNotification('❌ Error al limpiar logs: ' + error.message, 'error');
      }
    },

    formatTime (timestamp) {
      return new Date(timestamp).toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    getLogIcon (level) {
      const icons = {
        info: 'bi-info-circle',
        warning: 'bi-exclamation-triangle',
        error: 'bi-x-circle'
      };
      return icons[level] || 'bi-info-circle';
    },

    // === ANALYTICS - CLOUDFLARE ===
    async fetchCloudflareAnalytics () {
      try {
        const data = await this.apiCall('/api/cloudflare-analytics');

        if (data.success) {
          this.cfConnected = data.source === 'cloudflare_api';
          this.cloudflareMetrics = [
            { id: 1, icon: 'bi-people', value: data.metrics.visits.toLocaleString(), label: 'Visitas' },
            { id: 2, icon: 'bi-graph-up', value: data.metrics.bandwidth, label: 'Banda' },
            { id: 3, icon: 'bi-shield-check', value: data.metrics.threats, label: 'Amenazas' },
            { id: 4, icon: 'bi-hdd', value: `${data.metrics.cached}%`, label: 'Cache' },
            { id: 5, icon: 'bi-eye', value: data.metrics.pageviews.toLocaleString(), label: 'Pageviews' }
          ];
          this.showNotification('Datos de Cloudflare actualizados', 'success');
        }
      } catch (error) {
        this.cfConnected = false;
        this.showNotification('No se pudo conectar a Cloudflare', 'warning');
      }
    },

    // === UTILIDADES GENERALES ===
    async apiCall (endpoint, options = {}) {
      try {
        const url = `${this.backendUrl}${endpoint}`;
        const config = {
          headers: {
            'Content-Type': 'application/json',
            ...(this.adminToken && { Authorization: `Bearer ${this.adminToken}` }),
            ...options.headers
          },
          ...options
        };

        const response = await fetch(url, config);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        console.error('API Error:', error);
        this.showNotification(`Error de conexión: ${error.message}`, 'error');
        throw error;
      }
    },

    showNotification (message, type) {
      if (this.timers.notification) {
        clearTimeout(this.timers.notification);
      }

      this.notification = { show: true, message, type };
      this.timers.notification = setTimeout(() => {
        this.notification.show = false;
      }, 4000);
    },

    // === NUEVO: Limpiar todos los timers ===
    clearAllTimers () {
      Object.values(this.timers).forEach(timer => {
        if (timer) clearTimeout(timer);
      });
      this.timers = {
        autoLogout: null,
        debounce: null,
        notification: null
      };
    },

    // === GOOGLE ANALYTICS ===
    async saveGAConfig () {
      try {
        await this.apiCall('/api/save-ga-config', {
          method: 'POST',
          body: JSON.stringify({ ga_tracking_id: this.gaTrackingID })
        });
        localStorage.setItem('gaTrackingID', this.gaTrackingID);
        this.showNotification('Configuración GA guardada', 'success');
      } catch (error) {
        this.showNotification('Error guardando GA', 'error');
      }
    },

    // === ACCIONES RÁPIDAS ===
    async quickAction (action) {
      try {
        const result = await this.apiCall('/api/quick-action', {
          method: 'POST',
          body: JSON.stringify({ action })
        });
        this.showNotification(`Acción ${action} ejecutada`, 'success');
      } catch (error) {
        this.showNotification(`Error en ${action}`, 'error');
      }
    },

    // === BACKUP REAL ===
    async createBackup () {
      try {
        const result = await this.apiCall('/api/create-real-backup', {
          method: 'POST'
        });
        this.showNotification('Backup creado exitosamente', 'success');
      } catch (error) {
        this.showNotification('Error creando backup', 'error');
      }
    },

    // === PERFORMANCE TEST REAL ===
    async runPerformanceTest () {
      try {
        const result = await this.apiCall('/api/run-performance-test', {
          method: 'POST'
        });
        this.performanceMetrics.loadTime = result.results.loadTime;
        this.showNotification('Test de performance completado', 'success');
      } catch (error) {
        this.showNotification('Error en test de performance', 'error');
      }
    },

    // === GESTOR ARCHIVOS ===
    async openFileManager () {
      try {
        const result = await this.apiCall('/api/files');
        this.fileStats = await this.apiCall('/api/file-stats');
        this.showNotification('Gestor de archivos listo', 'success');
      } catch (error) {
        this.showNotification('Error abriendo gestor', 'error');
      }
    },

    // === NUEVO: loadFileStats ===
    async loadFileStats () {
      try {
        this.fileStats = await this.apiCall('/api/file-stats');
      } catch (error) {
        console.error('Error cargando stats de archivos:', error);
      }
    },

    // === CONSOLA SERVIDOR ===
    async executeConsole () {
      if (!this.consoleInput.trim()) {
        this.showNotification('Escribe un comando', 'warning');
        return;
      }

      try {
        const result = await this.apiCall('/api/console', {
          method: 'POST',
          body: JSON.stringify({ command: this.consoleInput })
        });

        this.consoleLogs.push({
          id: Date.now(),
          type: 'command',
          message: '> ' + this.consoleInput
        });

        this.consoleLogs.push({
          id: Date.now() + 1,
          type: 'result',
          message: '← ' + result.output
        });

        this.consoleInput = '';
      } catch (error) {
        this.showNotification('Error ejecutando comando', 'error');
      }
    },

    clearConsole () {
      this.consoleLogs = [];
    },

    // === HEATMAPS ===
    async saveHeatmapSettings () {
      try {
        await this.apiCall('/api/analytics-settings', {
          method: 'POST',
          body: JSON.stringify({
            heatmaps_enabled: this.heatmapsEnabled,
            track_clicks: this.trackClicks,
            track_scroll: this.trackScroll,
            track_mouse: this.trackMouse
          })
        });
        this.showNotification('Configuración heatmaps guardada', 'success');
      } catch (error) {
        this.showNotification('Error guardando heatmaps', 'error');
      }
    },

    // === MÉTODOS FALTANTES ===
    getTodayLogsCount () {
      const today = new Date().toDateString();
      return this.systemLogs.filter(log =>
        new Date(log.created_at).toDateString() === today
      ).length;
    },

    getNotificationIcon (type) {
      const icons = {
        success: 'bi-check-circle',
        error: 'bi-x-circle',
        info: 'bi-info-circle',
        warning: 'bi-exclamation-triangle'
      };
      return icons[type] || 'bi-info-circle';
    },

    // === EJECUTAR TODAS LAS ACCIONES ===
    async executeAllActions () {
      const actions = ['flushCache', 'optimizeDB', 'generateReport'];
      for (const action of actions) {
        await this.quickAction(action);
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    },

    // === NUEVO: Métodos para el simulador ===
    refreshSimulator () {
      this.showNotification('Simulador actualizado', 'success');
    },

    showBackups () {
      this.showNotification('Mostrando backups disponibles', 'info');
    }
  },

  watch: {
    autoLogoutMinutes: {
      handler (newVal) {
        if (this.isAuthenticated) {
          clearTimeout(this.timers.debounce);
          this.timers.debounce = setTimeout(() => {
            this.saveSecuritySettings();
            this.setupAutoLogout();
          }, 1500);
        }
      },
      immediate: false
    }
  },

 // ✅ CORREGIDO: mounted mejorado con verificación de páginas
async mounted () {
  // Verificar si es acceso privado
  const urlParams = new URLSearchParams(window.location.search);
  this.isPrivateAccess = urlParams.get('private') === 'true';

  // ... resto del mounted

  console.log('🚀 Componente AdminL2 montado');
  try {
    // Verificar autenticación PRIMERO
    const isAuth = await this.verifyAuth();

    if (isAuth) {
      console.log('✅ Usuario autenticado, cargando datos...');
      // Los datos ya se cargan en verifyAuth -> loadInitialData

      // ✅ NUEVO: Verificar estado de páginas después de cargar
      setTimeout(() => {
        this.verifyPagesState();
      }, 1000);
    } else {
      console.log('❌ Usuario NO autenticado');
    }
  } catch (error) {
    console.error('Error en mounted:', error);
  }
},
  beforeUnmount () {
    this.clearAllTimers();
  }
}
</script>

<style scoped>
/* ===== VARIABLES Y ESTILOS BASE ===== */
:root {
  --color-background: #0F1420;
  --color-surface: #1A2235;
  --color-primary: #5C8DF6;
  --color-text-primary: #E8EDF5;
  --color-text-secondary: #8A9BB0;
  --color-accent: #6366F1;
  --color-success: #10B981;
  --color-warning: #F59E0B;
  --color-error: #EF4444;
  --color-info: #3B82F6;

  --border-radius: 12px;
  --border-radius-sm: 8px;
  --border-radius-xs: 6px;

  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.5);

  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.admin-container {
  min-height: 100vh;
  background: var(--color-background);
  color: var(--color-text-primary);
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
  line-height: 1.6;
}

/* ===== MODAL DE CONTRASEÑA (MANTENIDO) ===== */
.password-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
}

.password-modal {
  background: var(--color-surface);
  border-radius: var(--border-radius);
  padding: 2.5rem;
  width: 100%;
  max-width: 440px;
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: modalSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.modal-header h2 {
  margin: 0;
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.security-badge {
  background: var(--color-primary);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
}

.modal-body {
  margin-bottom: 2rem;
}

.password-input-container {
  margin-bottom: 1.5rem;
}

.password-input-container label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius-xs);
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-text-primary);
  font-size: 0.9rem;
  transition: var(--transition);
}

.password-input:focus {
  border-color: var(--color-primary);
  background: rgba(255, 255, 255, 0.12);
  outline: none;
  box-shadow: 0 0 0 2px rgba(92, 141, 246, 0.1);
}

.visibility-toggle {
  position: absolute;
  right: 0.5rem;
  background: none;
  border: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: var(--transition);
}

.visibility-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.password-strength {
  margin-top: 0.5rem;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
}

.strength-bar {
  height: 100%;
  transition: var(--transition);
}

.strength-bar.empty { background: transparent; }
.strength-bar.weak { background: var(--color-error); width: 25%; }
.strength-bar.medium { background: var(--color-warning); width: 50%; }
.strength-bar.strong { background: var(--color-success); width: 100%; }

.modal-footer {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.login-btn, .exit-btn {
  flex: 1;
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: var(--border-radius-sm);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.login-btn {
  background: var(--color-primary);
  color: white;
}

.login-btn:hover:not(:disabled) {
  background: rgba(92, 141, 246, 0.9);
  transform: translateY(-2px);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.exit-btn {
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-text-primary);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.exit-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

.security-notice {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.security-notice p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.shake {
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

@keyframes shake {
  10%, 90% { transform: translateX(-1px); }
  20%, 80% { transform: translateX(2px); }
  30%, 50%, 70% { transform: translateX(-4px); }
  40%, 60% { transform: translateX(4px); }
}

/* ===== PANEL ADMIN PRINCIPAL ===== */
.admin-panel {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 80px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.admin-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.admin-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--color-text-primary);
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.status-badge {
  padding: 0.5rem 1.25rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid transparent;
}

.status-badge.active {
  background: rgba(16, 185, 129, 0.15);
  color: var(--color-success);
  border-color: rgba(16, 185, 129, 0.3);
}
.status-badge.maintenance {
  background: rgba(245, 158, 11, 0.15);
  color: var(--color-warning);
  border-color: rgba(245, 158, 11, 0.3);
}
.status-badge.private {
  background: rgba(239, 68, 68, 0.15);
  color: var(--color-error);
  border-color: rgba(239, 68, 68, 0.3);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.manual-btn, .logout-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: var(--border-radius-sm);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: inherit;
}

.manual-btn {
  background: rgba(59, 130, 246, 0.1);
  color: var(--color-info);
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.manual-btn:hover {
  background: rgba(59, 130, 246, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.2);
}

.logout-btn {
  background: rgba(239, 68, 68, 0.1);
  color: var(--color-error);
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.logout-btn:hover {
  background: rgba(239, 68, 68, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.2);
}

/* ===== NAVEGACIÓN ===== */
.admin-nav {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
  margin-bottom: 2.5rem;
}

.nav-btn {
  background: var(--color-surface);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--color-text-secondary);
  padding: 1.25rem 1.5rem;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  text-align: center;
  min-height: 60px;
}

.nav-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.nav-btn.active {
  background: var(--color-primary);
  color: white;
  border-color: var(--color-primary);
  box-shadow: 0 8px 20px rgba(92, 141, 246, 0.3);
}

/* ===== CONTENIDO DE SECCIONES ===== */
.section-content {
  animation: fadeInUp 0.4s ease;
}

.section-title {
  color: var(--color-text-primary);
  margin-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* ===== CONTROL GENERAL - GRID 2x3 FUSIONADO ===== */
.controls-grid-general-2x3 {
  display: grid;
  grid-template-areas:
    "mantenimiento acceso control"
    "alertas tema control";
  grid-template-columns: 1fr 1fr 1.2fr;
  grid-template-rows: auto auto;
  gap: 1.5rem;
}

.mantenimiento { grid-area: mantenimiento; }
.acceso { grid-area: acceso; }
.control { grid-area: control; }
.alertas { grid-area: alertas; }
.tema { grid-area: tema; }

.grid-row-1, .grid-row-2 {
  display: contents;
}

/* ===== CARDS BASE ===== */
.control-card {
  background: var(--color-surface);
  padding: 1.75rem;
  border-radius: var(--border-radius);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: var(--transition);
  height: fit-content;
}

.control-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
  border-color: rgba(255, 255, 255, 0.15);
}

.control-card-tall {
  grid-row: span 2;
  height: auto;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.control-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.25rem;
}

.control-header h3 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.control-card p {
  color: var(--color-text-secondary);
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* ===== SWITCH MEJORADO ===== */
.switch {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 28px;
  flex-shrink: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.2);
  transition: var(--transition);
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: var(--transition);
  border-radius: 50%;
  box-shadow: var(--shadow-sm);
}

input:checked + .slider {
  background: var(--color-success);
  border-color: var(--color-success);
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.switch-small {
  width: 44px;
  height: 22px;
}

.switch-small .slider:before {
  height: 16px;
  width: 16px;
}

/* ===== CONTROLES DE FORMULARIO ===== */
.message-input, .password-input-small, .api-input, .number-input, .ip-input {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius-xs);
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-text-primary);
  font-size: 0.9rem;
  transition: var(--transition);
  font-family: inherit;
}

.message-input:focus, .password-input-small:focus,
.api-input:focus, .number-input:focus, .ip-input:focus {
  border-color: var(--color-primary);
  background: rgba(255, 255, 255, 0.12);
  outline: none;
  box-shadow: 0 0 0 2px rgba(92, 141, 246, 0.1);
}

.message-input {
  resize: vertical;
  min-height: 80px;
}

/* ===== BOTONES ===== */
.save-btn, .action-btn, .refresh-btn, .clear-btn {
  background: var(--color-primary);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.9rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: inherit;
}

.save-btn:hover, .action-btn:hover {
  background: rgba(92, 141, 246, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(92, 141, 246, 0.3);
}

.refresh-btn, .clear-btn {
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-text-primary);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.5rem 0.75rem;
}

.refresh-btn:hover, .clear-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

.full-width {
  width: 100%;
  justify-content: center;
}

/* ===== CHECKBOX MEJORADO ===== */
.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  transition: var(--transition);
  padding: 0.5rem;
  border-radius: var(--border-radius-xs);
  color: var(--color-text-primary);
}

.checkbox-label:hover {
  background: rgba(255, 255, 255, 0.05);
}

.checkbox-label input {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  margin-right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
  flex-shrink: 0;
}

.checkbox-label input:checked + .checkmark {
  background: var(--color-primary);
  border-color: var(--color-primary);
}

.checkbox-label input:checked + .checkmark:after {
  content: '✓';
  color: white;
  font-size: 12px;
  font-weight: bold;
}

/* ===== CONTROL DE PÁGINAS ===== */
.pages-list {
  margin-top: 1rem;
  flex: 1;
  overflow-y: auto;
}

.page-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: var(--transition);
}

.page-item:hover {
  background: rgba(255, 255, 255, 0.03);
}

.page-item:last-child {
  border-bottom: none;
}

.page-name {
  color: var(--color-text-primary);
  font-weight: 500;
  flex: 1;
}

.page-status {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  margin-left: 1rem;
}

.page-status.active {
  background: rgba(16, 185, 129, 0.15);
  color: var(--color-success);
}

.page-status.blocked {
  background: rgba(239, 68, 68, 0.15);
  color: var(--color-error);
}

/* ===== SISTEMA DE ALERTAS ===== */
.alerts-list {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 1rem;
}

.alert-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: var(--border-radius-xs);
  margin-bottom: 0.5rem;
  transition: var(--transition);
}

.alert-warning {
  background: rgba(245, 158, 11, 0.1);
  border-left: 3px solid var(--color-warning);
}

.alert-success {
  background: rgba(16, 185, 129, 0.1);
  border-left: 3px solid var(--color-success);
}

.alert-info {
  background: rgba(59, 130, 246, 0.1);
  border-left: 3px solid var(--color-info);
}

.alert-error {
  background: rgba(239, 68, 68, 0.1);
  border-left: 3px solid var(--color-error);
}

.alert-icon {
  font-size: 1.1rem;
  display: flex;
  align-items: center;
}

.alert-text {
  flex: 1;
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.alert-time {
  color: var(--color-text-secondary);
  font-size: 0.8rem;
}

.no-alerts {
  text-align: center;
  color: var(--color-text-secondary);
  padding: 2rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.alerts-stats {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: var(--color-text-secondary);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1rem;
}

/* ===== TEMAS Y COLOR PICKERS ===== */
.theme-controls {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.theme-presets {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.preset-btn {
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--border-radius-sm);
  color: white;
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
}

.preset-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.color-customization {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.color-picker-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.color-picker-group label {
  min-width: 100px;
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.color-picker-group input[type="color"] {
  width: 60px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius-xs);
  background: rgba(255, 255, 255, 0.08);
  cursor: pointer;
  transition: var(--transition);
}

.color-picker-group input[type="color"]:hover {
  border-color: var(--color-primary);
  transform: scale(1.05);
}

/* ===== SEGURIDAD - CARDS UNIFORMES ===== */
.controls-grid-security-uniform {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.security-card {
  min-height: 480px;
  display: flex;
  flex-direction: column;
}

.security-card .advanced-controls,
.security-card .firewall-controls {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.advanced-badge {
  background: var(--color-primary);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.advanced-controls {
  margin-top: 1.25rem;
}

.setting-group {
  margin-bottom: 1.25rem;
}

.setting-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.security-select, .country-select, .log-filter, .device-select {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius-xs);
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-text-primary);
  font-size: 0.9rem;
  transition: var(--transition);
  font-family: inherit;
  cursor: pointer;
}

.security-select:focus, .country-select:focus,
.log-filter:focus, .device-select:focus {
  border-color: var(--color-primary);
  background: rgba(255, 255, 255, 0.12);
  outline: none;
  box-shadow: 0 0 0 2px rgba(92, 141, 246, 0.1);
}

.password-change {
  display: flex;
  gap: 0.75rem;
}

/* ===== FIREWALL STYLES ===== */
.firewall-controls {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.ip-management, .active-blocks {
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.ip-management h4, .active-blocks h4 {
  margin: 0 0 1rem 0;
  color: var(--color-text-primary);
  font-size: 1rem;
  font-weight: 600;
}

.ip-input-group {
  display: flex;
  gap: 0.75rem;
}

.blocked-list {
  max-height: 120px;
  overflow-y: auto;
}

.blocked-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border-radius: var(--border-radius-xs);
  background: rgba(255, 255, 255, 0.05);
  margin-bottom: 0.5rem;
}

.blocked-ip {
  font-family: 'Courier New', monospace;
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.remove-btn {
  background: var(--color-error);
  color: white;
  border: none;
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-btn:hover {
  background: rgba(239, 68, 68, 0.8);
  transform: scale(1.05);
}

.more-blocks {
  text-align: center;
  color: var(--color-text-secondary);
  font-size: 0.8rem;
  padding: 0.5rem;
}

/* ===== LOGS STYLES ===== */
.log-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.logs-container-uniform {
  background: rgba(255, 255, 255, 0.05);
  border-radius: var(--border-radius-sm);
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.log-entries-uniform {
  max-height: 300px;
  overflow-y: auto;
  font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
  font-size: 0.8rem;
  flex: 1;
}

.log-entry {
  display: grid;
  grid-template-columns: 60px 80px 1fr;
  gap: 1rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  align-items: center;
  transition: var(--transition);
}

.log-entry:hover {
  background: rgba(255, 255, 255, 0.03);
}

.log-entry:last-child {
  border-bottom: none;
}

.log-time {
  color: var(--color-text-secondary);
  font-size: 0.75rem;
}

.log-level {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}

.log-level.info {
  background: rgba(59, 130, 246, 0.2);
  color: var(--color-info);
}

.log-level.warning {
  background: rgba(245, 158, 11, 0.2);
  color: var(--color-warning);
}

.log-level.error {
  background: rgba(239, 68, 68, 0.2);
  color: var(--color-error);
}

.log-message {
  color: var(--color-text-primary);
  flex: 1;
  line-height: 1.4;
}

.logs-stats-real {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  font-size: 0.8rem;
}

.export-btn {
  background: rgba(16, 185, 129, 0.1);
  color: var(--color-success);
  border: 1px solid rgba(16, 185, 129, 0.2);
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius-xs);
  cursor: pointer;
  font-size: 0.8rem;
  transition: var(--transition);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.export-btn:hover {
  background: rgba(16, 185, 129, 0.15);
}

/* ===== ANÁLISIS STYLES ===== */
.analytics-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cloudflare-section {
  background: var(--color-surface);
  padding: 1.75rem;
  border-radius: var(--border-radius);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.api-status {
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.api-status.connected {
  background: rgba(16, 185, 129, 0.15);
  color: var(--color-success);
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.api-status.disconnected {
  background: rgba(245, 158, 11, 0.15);
  color: var(--color-warning);
  border: 1px solid rgba(245, 158, 11, 0.3);
}

.cloudflare-metrics {
  margin-top: 1.5rem;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.metric-card {
  background: rgba(255, 255, 255, 0.05);
  padding: 1.5rem;
  border-radius: var(--border-radius-sm);
  text-align: center;
  transition: var(--transition);
  border: 1px solid transparent;
}

.metric-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.metric-icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
  opacity: 0.9;
  display: flex;
  justify-content: center;
}

.metric-data {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.metric-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-primary);
  line-height: 1.2;
}

.metric-label {
  font-size: 0.8rem;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.charts-placeholder {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.charts-placeholder h4 {
  margin: 0 0 0.75rem 0;
  color: var(--color-text-primary);
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.charts-placeholder p {
  color: var(--color-text-secondary);
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.chart-container {
  background: rgba(255, 255, 255, 0.05);
  border-radius: var(--border-radius-sm);
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.chart-placeholder {
  height: 200px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 1rem 0;
}

.placeholder-bars {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
}

.bar {
  flex: 1;
  background: linear-gradient(to top, var(--color-primary), rgba(92, 141, 246, 0.7));
  border-radius: 4px 4px 0 0;
  min-height: 10px;
  transition: var(--transition);
}

.bar:hover {
  opacity: 0.8;
}

.refresh-btn.large {
  padding: 1rem 2rem;
  font-size: 1rem;
  margin-top: 1.5rem;
}

.analytics-cards-uniform {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.analytics-card {
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.analytics-card .ga-config,
.analytics-card .heatmap-controls,
.analytics-card .performance-metrics {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.performance-metrics {
  gap: 1rem;
}

.perf-metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.perf-metric .metric-label {
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.perf-metric .metric-value {
  font-size: 1rem;
  font-weight: 600;
}

/* ===== HERRAMIENTAS DEV STYLES ===== */
.devtools-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.devtools-cards-uniform {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.devtools-card {
  min-height: 220px;
  display: flex;
  flex-direction: column;
}

.quick-actions-list-compact {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex: 1;
}

.quick-action-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--color-text-primary);
  padding: 0.75rem;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.85rem;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.quick-action-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.file-stats-compact,
.backup-info-compact {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
}

.stat-item, .detail-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
}

.backup-status {
  margin-bottom: 1rem;
}

.backup-actions {
  display: flex;
  gap: 0.75rem;
}

.backup-actions .action-btn {
  flex: 1;
  justify-content: center;
}

/* ===== BOTONES DE VISTA CENTRADOS ===== */
.view-buttons-centered {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 1.5rem 0;
}

.view-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--color-text-primary);
  padding: 1rem 2rem;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition);
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.view-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
}

.view-btn.active {
  background: var(--color-primary);
  color: white;
  border-color: var(--color-primary);
  box-shadow: 0 4px 12px rgba(92, 141, 246, 0.3);
}

/* ===== ÁREA DE TRABAJO CENTRADA ===== */
.work-area-centered {
  background: var(--color-surface);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  height: auto;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex:2;
  overflow:hidden;
}
/* ===== CONSOLA REAL ===== */
.console-real {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: var(--border-radius-sm);
  overflow: hidden;
  font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
}

.console-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.console-header h4 {
  margin: 0;
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.console-output-real {
  flex: 1;
  padding: 1rem 1.5rem;
  overflow-y: auto;
  background: #1a1a1a;
  display: flex;
  flex-direction: column;
}

.console-line {
  margin-bottom: 0.5rem;
  padding: 0.25rem 0;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.console-line.command {
  color: var(--color-primary);
}

.console-line.result {
  color: var(--color-text-primary);
}

.console-line.error {
  color: var(--color-error);
}

.log-prefix {
  color: var(--color-text-secondary);
  font-weight: bold;
  min-width: 20px;
}

.console-input-integrated {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  background: rgba(0, 0, 0, 0.4);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  gap: 0.5rem;
}

.prompt {
  color: var(--color-primary);
  font-weight: bold;
}

.console-input-real {
  flex: 1;
  background: transparent;
  border: none;
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 0.9rem;
  outline: none;
}

.console-input-real::placeholder {
  color: var(--color-text-secondary);
}

/* ===== CONTENEDOR PRINCIPAL DEL SIMULADOR ===== */
.simulator-centered {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; /* Importante para flexbox */
}

.simulator-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 1.5rem;
  flex-shrink: 0; /* Evita que el header se encoja */
}

.simulator-header h4 {
  margin: 0;
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.device-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
}

/* ===== CONTENEDOR DEL FRAME DEL SIMULADOR ===== */
.simulator-frame-centered {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--border-radius-sm);
  padding: 1rem;
  overflow: auto;
  min-height: 0; /* Crítico para flexbox */
  position: relative;
  height: auto;
  max-height:none;
}

/* ===== IFRAME DEL SITIO ===== */
.site-preview-responsive {
  border-radius: 12px;
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: white;
  transition: all 0.3s ease;
  display:block;
}

/* ===== ESTILOS ESPECÍFICOS POR DISPOSITIVO ===== */

/* MOBILE - Tamaño real sin escalado */
.mobile-device {
  width: 375px;
  height: 667px;
  transform: none;
  transform-origin: center center;
}

/* TABLET - Tamaño real sin escalado */
.tablet-device {
  width: 768px;
  height: 1024px;
  transform: none;
  transform-origin: center center;
}

/* DESKTOP - Tamaño real sin escalado */
.desktop-device {
  width: 1200px;
  height: 800px;
  transform: none;
  transform-origin: center center;
}

/* ===== ESCALADO AUTOMÁTICO PARA DISPOSITIVOS GRANDES ===== */
@media (max-width: 1400px) {
  .desktop-device {
    transform: scale(0.9);
  }
}

@media (max-width: 1300px) {
  .desktop-device {
    transform: scale(0.85);
  }
}

@media (max-width: 1200px) {
  .desktop-device {
    transform: scale(0.8);
  }
  
  .tablet-device {
    transform: scale(0.95);
  }
}

@media (max-width: 1100px) {
  .desktop-device {
    transform: scale(0.75);
  }
  
  .tablet-device {
    transform: scale(0.9);
  }
}

@media (max-width: 1000px) {
  .desktop-device {
    transform: scale(0.7);
  }
  
  .tablet-device {
    transform: scale(0.85);
  }
  
  .mobile-device {
    transform: scale(0.95);
  }
}

@media (max-width: 900px) {
  .tablet-device {
    transform: scale(0.8);
  }
  
  .mobile-device {
    transform: scale(0.9);
  }
}

@media (max-width: 800px) {
  .tablet-device {
    transform: scale(0.75);
  }
  
  .mobile-device {
    transform: scale(0.85);
  }
}

@media (max-width: 700px) {
  .tablet-device {
    transform: scale(0.7);
  }
  
  .mobile-device {
    transform: scale(0.8);
  }
}

@media (max-width: 600px) {
  .tablet-device {
    transform: scale(0.65);
  }
  
  .mobile-device {
    transform: scale(0.75);
  }
}

@media (max-width: 500px) {
  .tablet-device {
    transform: scale(0.6);
  }
  
  .mobile-device {
    transform: scale(0.7);
  }
}
/* ===== NOTIFICACIONES ===== */
.notification {
  position: fixed;
  top: 2rem;
  right: 2rem;
  padding: 1rem 1.5rem;
  border-radius: var(--border-radius-sm);
  color: white;
  font-weight: 600;
  z-index: 10000;
  animation: slideInRight 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  max-width: 400px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.notification.success { background: rgba(16, 185, 129, 0.9); }
.notification.error { background: rgba(239, 68, 68, 0.9); }
.notification.info { background: rgba(59, 130, 246, 0.9); }
.notification.warning { background: rgba(245, 158, 11, 0.9); }

/* ===== ANIMACIONES ===== */
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* ===== SCROLLBAR PERSONALIZADO ===== */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===== RESPONSIVE PARA PC PEQUEÑAS ===== */
@media (max-width: 1000px) {
  .admin-panel {
    padding: 1.5rem;
  }

  .controls-grid-general-2x3 {
    grid-template-areas:
      "mantenimiento acceso"
      "alertas tema"
      "control control";
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
  }

  .control-card-tall {
    grid-row: auto;
    min-height: 300px;
  }

  .controls-grid-security-uniform {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .security-card {
    min-height: auto;
  }

  .analytics-cards-uniform,
  .devtools-cards-uniform {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .metrics-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .admin-nav {
    grid-template-columns: repeat(2, 1fr);
  }

  .admin-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .header-right {
    width: 100%;
    justify-content: center;
  }

  .work-area-centered {
    height: 55vh;
    padding: 1rem;
  }

  .simulator-frame-centered {
    padding: 1rem;
  }
}
/* ===== OVERLAY DE WEBPACK - OCULTAR O ESTILIZAR ===== */
#webpack-dev-server-client-overlay {
  display: none !important;
}

/* ===== INDICADOR DE ESCALA ===== */
.scale-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  z-index: 10;
}

/* ===== BOTÓN DE RESET DE ESCALA ===== */
.reset-scale-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--color-text-primary);
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius-xs);
  cursor: pointer;
  font-size: 0.8rem;
  transition: var(--transition);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.reset-scale-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* ===== SCROLLBAR MEJORADO PARA EL SIMULADOR ===== */
.simulator-frame-centered::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.simulator-frame-centered::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

.simulator-frame-centered::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  border: 2px solid transparent;
  background-clip: content-box;
}

.simulator-frame-centered::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
  border: 2px solid transparent;
  background-clip: content-box;
}

/* ===== ANIMACIÓN SUAVE PARA CAMBIOS DE DISPOSITIVO ===== */
.site-preview-responsive {
  animation: deviceSwitch 0.4s ease-out;
}

@keyframes deviceSwitch {
  0% {
    opacity: 0.7;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

</style>
